import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL, eventSelectScreenSelection } from 'store/actions';
import {
  selectBillingProductIds,
  selectBillingProductsUnits,
  selectBillingProducts,
} from 'store/remote/selectors';
import { randomKey } from 'lib/riskbase';
import { doAddEvent, doRemoveEvents } from 'lib/events';
import { BillingProductCard } from './BillingProductCard';
import { BillingProductUnitCard } from './BillingProductUnitCard';
import { GapSmall } from 'components/GapSmall';

type Props = {};

export const BillingProductCards: React.FC<Props> = () => {
  const dispatch = useDispatch();
  const eventKeyProductUnits = React.useRef(randomKey());

  const products = useSelector(selectBillingProducts) || [];
  const productIds = useSelector(selectBillingProductIds) || [];
  const productUnits = useSelector(selectBillingProductsUnits) || [];
  const productUnitProductIds = productUnits.map((pu) => pu.productId);

  const productsWithoutUnits = products.filter(
    (p) => !productUnitProductIds.includes(p.id),
  );

  React.useEffect(() => {
    const events = [
      doAddEvent(eventSelectScreenSelection, (action) => {
        if (action.payload.key === eventKeyProductUnits.current) {
          const productId = action.payload.stringValues[0];
          if (productId) {
            dispatch(
              NAVIGATE_MODAL({
                screen: ModalScreens.SettingsBillingProductUnits,
                params: {
                  productId,
                },
              }),
            );
          }
        }
      }),
    ];
    return () => {
      doRemoveEvents(events);
    };
  }, [dispatch]);

  return (
    <>
      <GapSmall>
        {!!productIds.length && (
          <Card label="Products">
            {productIds.map((productId) => (
              <BillingProductCard key={productId} productId={productId} />
            ))}
          </Card>
        )}
        <Card>
          <CardRow
            label="Add product..."
            labelColor={theme.colors.blue}
            icon={ICONS.PlusLight}
            iconColor={theme.colors.blue}
            onPress={() =>
              dispatch(
                NAVIGATE_MODAL({
                  screen: ModalScreens.SettingsBillingProduct,
                  params: { productId: null },
                }),
              )
            }
          />
        </Card>
      </GapSmall>
      {!!productIds.length && (
        <GapSmall>
          <Card label="Product Units" />
          {!!productUnitProductIds.length && (
            <Card>
              {productIds
                .filter((productId) =>
                  productUnitProductIds.includes(productId),
                )
                .map((productId) => (
                  <BillingProductUnitCard
                    key={productId}
                    productId={productId}
                  />
                ))}
            </Card>
          )}
          {!!productsWithoutUnits.length && (
            <Card>
              <CardRow
                label="Add product units..."
                labelColor={theme.colors.blue}
                icon={ICONS.PlusLight}
                iconColor={theme.colors.blue}
                onPress={() =>
                  dispatch(
                    NAVIGATE_MODAL({
                      screen: ModalScreens.SELECT,
                      params: {
                        title: 'Products',
                        eventKey: eventKeyProductUnits.current,
                        options: productsWithoutUnits.map((p) => ({
                          name: p.name,
                          internalValue: p.id,
                        })),
                      },
                      size: 'small',
                    }),
                  )
                }
              />
            </Card>
          )}
        </GapSmall>
      )}
    </>
  );
};
